"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ASSETS_GUILD_MARKS = exports.ASSETS_INTERFACE_SOUNDS = exports.ASSETS_INTERFACE = exports.ASSETS_ENVIRONMENT_SOUNDS = exports.ASSETS_PANORAMAS = exports.ASSETS_MUSIC = exports.ASSETS_RACES = exports.ASSETS_SKILLCOMBOS = exports.ASSETS_SKILLS = exports.ASSETS_ITEMS = exports.ASSETS_EFFECTS = exports.ASSETS_LOGOS = void 0;
var ASSETS_HOST = "https://cdn.fhxrestoration.com/common";
var ASSETS_LOGOS = "".concat(ASSETS_HOST, "/logos");
exports.ASSETS_LOGOS = ASSETS_LOGOS;
var ASSETS_EFFECTS = "".concat(ASSETS_HOST, "/effects");
exports.ASSETS_EFFECTS = ASSETS_EFFECTS;
var ASSETS_ITEMS = "".concat(ASSETS_HOST, "/entities/items");
exports.ASSETS_ITEMS = ASSETS_ITEMS;
var ASSETS_SKILLS = "".concat(ASSETS_HOST, "/entities/skills");
exports.ASSETS_SKILLS = ASSETS_SKILLS;
var ASSETS_SKILLCOMBOS = "".concat(ASSETS_HOST, "/entities/skillCombos");
exports.ASSETS_SKILLCOMBOS = ASSETS_SKILLCOMBOS;
var ASSETS_RACES = "".concat(ASSETS_HOST, "/entities/characterRaces");
exports.ASSETS_RACES = ASSETS_RACES;
var ASSETS_MUSIC = "".concat(ASSETS_HOST, "/music");
exports.ASSETS_MUSIC = ASSETS_MUSIC;
var ASSETS_PANORAMAS = "".concat(ASSETS_HOST, "/backgrounds/panoramas");
exports.ASSETS_PANORAMAS = ASSETS_PANORAMAS;
var ASSETS_ENVIRONMENT_SOUNDS = "".concat(ASSETS_HOST, "/environment/sounds");
exports.ASSETS_ENVIRONMENT_SOUNDS = ASSETS_ENVIRONMENT_SOUNDS;
var ASSETS_INTERFACE = "".concat(ASSETS_HOST, "/interface");
exports.ASSETS_INTERFACE = ASSETS_INTERFACE;
var ASSETS_INTERFACE_SOUNDS = "".concat(ASSETS_INTERFACE, "/sounds");
exports.ASSETS_INTERFACE_SOUNDS = ASSETS_INTERFACE_SOUNDS;
var ASSETS_GUILD_MARKS = "".concat(ASSETS_HOST, "/entities/guilds/icons");
exports.ASSETS_GUILD_MARKS = ASSETS_GUILD_MARKS;